import React from "react";
import { Grid } from "@material-ui/core";
import SelectCountries from "./SelectAvailableCountries";
import SelectWithStateFromCountries from "./SelectWithStateFromCountries";
import SelectWithCitiesFromStates from "./SelectWithCitiesFromStates";

const DefaultWrapper = React.memo(({ children }) => (
  <Grid
    item
    xs={12}
    sm={6}
    md={6}
  >
    {children}
  </Grid>
));

const SelectLocation = ({
  fetchStatesEnabled,
  fetchCitiesEnabled,
  selectedCountries,
  setSelectedCountries,
  selectedStates,
  setSelectedStates,
  selectedCities,
  setSelectedCities,
  Wrapper = DefaultWrapper,
}) => {
  const handleCountriesChange = (countries) => {
    setSelectedCountries(countries);

    if (fetchStatesEnabled) {
      setSelectedStates([]);
    }

    if (fetchCitiesEnabled) {
      setSelectedCities([]);
    }
  };

  const handleStatesChange = (states) => {
    setSelectedStates(states);

    if (fetchCitiesEnabled) {
      setSelectedCities([]);
    }
  };

  return (
    <>
      <Wrapper>
        <SelectCountries
          selectedCountries={selectedCountries}
          setSelectedCountries={handleCountriesChange}
        />
      </Wrapper>

      {fetchStatesEnabled && (
        <Wrapper>
          <SelectWithStateFromCountries
            selectedCountries={selectedCountries}
            selectedStates={selectedStates}
            setSelectedStates={handleStatesChange}
          />
        </Wrapper>
      )}

      {fetchCitiesEnabled && (
        <Wrapper>
          <SelectWithCitiesFromStates
            selectedStates={selectedStates}
            selectedCities={selectedCities}
            setSelectedCities={setSelectedCities}
          />
        </Wrapper>
      )}
    </>
  );
};

export default React.memo(SelectLocation);
